import React from "react";
import NavBar from "../../NavBar"
import Footer from "../../Footer"
import dati from "../../../data/telefonoProdotti.json";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { useEffect } from "react";
import ScrollabileRiga from "../ScrollabileRiga";
import Selezione from "../Selezione"

export default function Cover(){

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    function tornaSopra(){
        document.body.scrollTop = 0; 
        document.documentElement.scrollTop = 0;
    }
    useEffect(() => {
            window.addEventListener("scroll",(e)=>{
            const bottone = document.getElementById("btnTop");
            if(window.scrollY===0){
                try {
                    bottone.classList.add("invisibile");
                } catch (error) {
                    return null;
                }
                
                
                setTimeout(() => {
                    try {
                        bottone.classList.add("invisibilePerDavvero")
                    } catch (error) {
                        return null;
                    }
                    
                }, "490");
                try {
                    bottone.classList.remove("visibile");
                } catch (error) {
                    return null;
                }
                
            }else{
                try {
                    bottone.classList.remove("invisibile");
                    bottone.classList.remove("invisibilePerDavvero");
                    bottone.classList.add("visibile");
                } catch (error) {
                    return null;
                }
                
            }
            
        });
        
    });
    
    const arrId = ["Cuffie Attacco Jack","Cuffie Attacco C - Lightning","Powerbank"]
        
    return (
        <div className="coverBody wuXieKeJi">
            <button id="btnTop" onClick={()=>tornaSopra()}><FontAwesomeIcon icon={faArrowUp} /></button>
            <NavBar uno ="Prodotti" due="Informazioni" tre="Contattaci" one="/prodotti" two="/informazioni" three="/contattaci"/>
            <h1 className="titoloProdotti">Cuffie e Powerbank</h1>
            <Selezione arr={arrId}/>
            
            <div className="colonna telefoni">

                <ScrollabileRiga idTitolo="CuffieAttaccoJack" titolo="Cuffie Attacco Jack" idScroll1="3" idScroll2="4" dati={dati} tipo="cuffie" sottoTipo1="jackB" sottoTipo2="jackA" nomeDati="telefonoProdotti"/>

                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="CuffieAttaccoC-Lightning" titolo="Cuffie Attacco C - Lightning" idScroll1="5" idScroll2="6" dati={dati} tipo="cuffie" sottoTipo1="attaccoC" sottoTipo2="attaccoL" nomeDati="telefonoProdotti"/>

                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="Powerbank" titolo="Powerbank" idScroll1="7" idScroll2="8" dati={dati} tipo="powerbank" sottoTipo1="riga1" sottoTipo2="riga2" nomeDati="telefonoProdotti"/>

            </div>
            <Footer />
        </div>
    )
}